import { useMutation } from '@sopranodesign/pulse-hooks';

import { setupDemo } from '../api/index';

const useSetupDemo = params => {
  const mutation = useMutation({
    mutationFn: setupDemo,
    ...params
  });

  return mutation;
};

export default useSetupDemo;
